module.exports = __webpack_public_path__ + "pr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pr.svg
// module id = 1020
// module chunks = 0